<!-- 牌照展示 -->
<template>
    <div class="Licensedisplay">
        <div class="titleBOx">
               <h2 class="title">
                {{help.name21}}
            </h2>
        </div>
        <div class="content"> 
            <p class="tip1"> {{help.name30}}</p>
            <div class="box">
                <div class="leftbox">
                    <p> {{help.name31}}</p>
                    <img loading="lazy" v-lazy="require('../../assets/images/yy/help6.png')" alt="" sizes="" srcset="">
                </div>
                <div class="leftbox">
                    <p> {{help.name32}}</p>
                    <img loading="lazy" v-lazy="require('../../assets/images/yy/help7.png')" alt="" sizes="" srcset="">
                    <h3> {{help.name33}}</h3>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .Licensedisplay{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding-bottom: 60px;
               line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
            }
            .box{
                display: flex;
                justify-content: space-around;
                .leftbox{
                   p{
                        margin-bottom: 10px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        color: #666;
                   }
                   h3{
                        line-height: 50px;
                        font-size: 16px;
                        padding-top: 0px;
                        font-weight: 500;
                        text-align: center;
                   }
                }
            }
        }
    }
</style>